<template>
  <tela-component title="Saldo Pronta Entrega - Veterinária">
    <v-card flat rounded="lg">
      <v-card-text>
        <v-progress-linear v-if="loading"></v-progress-linear>
        <template v-else>
          <v-select
            label="Vendedor"
            :items="getVendedoresFiltrados()"
            item-text="nome"
            item-value="codigo"
            v-model="vendedorSelec"
            hide-details=""
          ></v-select>
          <v-radio-group label="Listar saldo por:" v-model="listar_por">            
            <v-radio label="Produto" value="1"></v-radio>
            <v-radio label="Nota fiscal" value="2"></v-radio>
          </v-radio-group>
          <v-btn
            rounded
            block
            color="info"
            depressed
            @click="gerarRelatorio()"
            class="mt-3"
            >Gerar Relatório</v-btn
          >
        </template>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapState } from "vuex";
export default {
  components: { TelaComponent },
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("base", ["vendedores"]),
  },
  data: () => ({
    loading: true,
    vendedorSelec: 0,
    listar_por: "1",
  }),
  methods: {
    ...mapActions("base", ["getVendedores"]),
    gerarRelatorio() {
      window.open(
        `${process.env.VUE_APP_BASE_URL}/nutricao-animal/relatorios/veterinaria?token=${this.usuarioLogado.token}&relat=SALDO-PRONTA-ENTREGA&cod_vendedor=${this.vendedorSelec}&listar_por=${this.listar_por}`,
        "_blank"
      );
    },
    getVendedoresFiltrados() {
      return this.vendedores.filter((v) => v.vendedor_coasul_ext && v.codigo > 0);
    },
  },
  async mounted() {
    this.loading = true;
    await this.getVendedores();
    this.vendedorSelec = this.getVendedoresFiltrados()[0].codigo;
    this.loading = false;
  },
};
</script>

<style>
</style>